// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1qnX9","rootSmall":"AddTileButton_rootSmall__3BrCa"};